import { buildUrl } from "src/utils/generateUrl";

const EVENTS_ROUTES = {
  EVENTS_DASHBOARD: "/events",
  EVENT_DETAIL: "/event/:id",
  EVENT_SLOT_SELECTION: "/event/:id/slot-selection",
};

export const ROUTES = {
  HOME: "/",
  ...EVENTS_ROUTES,
};

export const buildUrlV2 = (path: string, parameters: { [key: string]: string } = {}) =>
  `/v2${buildUrl(path, parameters)}`;
